import {useMemo, useState} from 'react';
import Link from 'next/link';
import {
    camelToTitleCase,
    classNames,
    resolveQs,
} from '@/lib/utils/commonUtils';
import CopyButton from '../CopyButton';
import ExpandFieldBtn from '@/components/ExpandFieldBtn';
import {get} from 'lodash-es';

export default function RecordCard({record, index}: { record: any; records?: [], index: number }) {
    const datalist = {
        class: {
            value: get(record, 'ResourceName._titleClass', '-'),
        },
        country: {
            value: get(record, 'CountryOfOrigin[0]', '-'),
            length: get(record, 'CountryOfOrigin.length', 0),
            values: get(record, 'CountryOfOrigin', []),
        },
        language: {
            value: get(record, 'OriginalLanguage[0].value', '-'),
            length: get(record, 'OriginalLanguage.length', 0),
            values: get(record, 'OriginalLanguage', []),
        },
        'release date': {
            value:
                String(get(record, 'ReleaseDate', ''))
                    .split('-')
                    .join('/') || '-',
        },
    };

    const [isShowCountries, setIsShowCountries] = useState(false);
    const [isShowLanguages, setIsShowLanguages] = useState(false);

    const {type: eomdType, Parent: eomdParent} = useMemo(() => {
        if (record.ExtraObjectMetadata) {
            const [key, value]: [string, any] = Object.entries(
                record.ExtraObjectMetadata,
            )[0];
            const type = camelToTitleCase(key).split(' ')[0]
            const {Parent} = value;

            return {type, Parent};
        }

        return {type: null, Parent: null};
    }, [record]);

    /*
        Class – a synthetic field containing any Class values from the record (Series, Season, Episode, Edit, Manifestation)
     */

    const {
        ResourceName,
        ID,
        ReferentType,
        CountryOfOrigin,
        OriginalLanguage,
        ReleaseDate,
        Language,
        ...rest
    } = record;

    const showCountries = () => {
        setIsShowCountries(!isShowCountries);
    };

    const showLanguages = () => {
        setIsShowLanguages(!isShowLanguages);
    };

    let classType = ['-'];
//SeriesInfo
    //EpisodeInfo

    const ExtraObjectMetadata = record.ExtraObjectMetadata;
    let [parentRecord, setParentRecord] = useState(null);
    if (ExtraObjectMetadata) {
        const [key, value] = Object.entries(ExtraObjectMetadata)[0];
        //console.log(key, value);
        if (key.indexOf("Info") > -1) {
            classType = value[key.replace("Info", "Class")];
            if (!Array.isArray(classType)) {
                classType = [classType]
            }
        }
    }

    /*
     <div className="flex mt-1">
                                {eomdType && eomdParent ? (
                                    <p>
                                        <span className="capitalize">{eomdType}</span>
                                        <span> of </span>
                                        <span>(</span>
                                        <Link
                                            className="text-theme-blue"
                                            href={resolveQs(eomdParent)}
                                        >
                                            view parent
                                        </Link>
                                        <span>)</span>
                                    </p>
                                ) : null}
                            </div>
     */


    return (
        <article
            className="record-card animate__animated animate__fadeIn"
            data-index={index}
        >
            <div className="base-object-metadata">
                <header>
                    <div className="flex justify-between items-start mb-2 md:items-center">
                        <h3 className="grow-1 pe-3">{ResourceName?.value}</h3>
                        <strong className="shrink-0">{record.ReferentType}</strong>
                    </div>
                    <hr/>
                    <div className="flex md:flex-row flex-col mb-2 mt-2 justify-between items-start">
                        <div className="w-full">
                            <div className="flex items-center mb-2 text-theme-blue">
                                <Link className="mr-2" href={resolveQs(record.ID)}>
                                    {record.ID}
                                </Link>
                                <CopyButton content={ID}/>
                            </div>

                        </div>
                        <div className="flex justify-end w-full">
                            <dl className="grid grid-cols-4 text-center gap-2 md:gap-4 mt-2 w-full">
                                <div>
                                    <dt>Class</dt>
                                    <dd>{classType}</dd>
                                </div>
                                <div>
                                    <dt>Country</dt>
                                    <dd>
                                        <div className="flex flex-row justify-center items-center">
                                            {datalist.country.value}
                                            {datalist.country.values.length > 2 && (
                                                <button
                                                    className="px-2 py-1 text-sm flex justify-center items-center hover:text-theme-blue"
                                                    type="button"
                                                    onClick={showCountries}
                                                >
                                                    <span
                                                        className="border-theme-blue rounded-xl px-2 py-1 text-sm flex flex-row items-center">+{datalist.country.values.length - 1}
                                                        {isShowCountries ? (
                                                            <i className="mio">keyboard_arrow_up</i>
                                                        ) : (
                                                            <i className="mio">keyboard_arrow_down</i>
                                                        )}
                                                        </span>
                                                </button>
                                            )}
                                        </div>
                                        {datalist.country.values.length > 2 &&
                                            <div
                                                className={"flex flex-col justify-center" + (isShowCountries ? "" : " hidden")}>

                                                {datalist.country.values.map((item, index) => {
                                                    if (index > 0) {
                                                        return <span key={index}>{item}</span>;
                                                    }
                                                })}

                                            </div>
                                        }
                                    </dd>
                                </div>
                                <div>
                                    <dt>Language</dt>
                                    <dd>
                                        <div className="flex flex-col justify-content-start">
                                            {datalist.language.value}
                                            {datalist.language.values.length > 1 && (
                                                <button
                                                    className="ms-4 px-2 py-1 text-sm flex flex-row justify-between items-center hover:text-theme-blue"
                                                    type="button"
                                                    onClick={showLanguages}
                                                >
                                                    <span
                                                        className="ms-4 border-theme-blue rounded-xl px-2 py-1 text-sm flex items-center">+{datalist.language.values.length - 1}

                                                        {isShowLanguages ? (
                                                            <i className="mio">keyboard_arrow_up</i>
                                                        ) : (
                                                            <i className="mio">keyboard_arrow_down</i>
                                                        )}
                                                        </span>
                                                </button>
                                            )}
                                        </div>
                                        <div
                                            className={"flex flex-col justify-center" + (isShowLanguages ? "" : " hidden")}>
                                            {datalist.language.values.length > 1
                                                ? datalist.language.values.map((item, index) => {
                                                    if (index > 0) {
                                                        return <span key={index}>{item}</span>;
                                                    }
                                                })
                                                : null}
                                        </div>
                                    </dd>
                                </div>
                                <div>
                                    <dt>Release Date</dt>
                                    <dd>{ReleaseDate}</dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </header>
            </div>
        </article>
    );
}